import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		redirectTo: 'devices',
	},
	{
		path: 'devices',
		pathMatch: 'full',
		loadComponent: () => import('./components/devices-list/devices-list.component').then((m) => m.DevicesListComponent),
		canActivate: [AuthGuard],
	},
	{
		path: 'device/:uuid',
		pathMatch: 'full',
		loadComponent: () =>
			import('./components/device-details/device-details.component').then((m) => m.DeviceDetailsComponent),
		canActivate: [AuthGuard],
	},
	{
		path: 'device/:uuid/mediaplan/edit',
		pathMatch: 'full',
		loadComponent: () =>
			import('./components/device/media-plan-edit-container/media-plan-edit-container.component').then(
				(m) => m.MediaPlanEditContainerComponent
			),
		canActivate: [AuthGuard],
	},
	{
		path: 'device/:uuid/config/edit',
		pathMatch: 'full',
		loadComponent: () =>
			import('./components/device/config-edit-container/config-edit-container.component').then(
				(m) => m.ConfigEditContainerComponent
			),
		canActivate: [AuthGuard],
	},
	{
		path: 'match',
		pathMatch: 'full',
		loadComponent: () => import('./components/match/match-list.component').then((m) => m.MatchListComponent),
		canActivate: [AuthGuard],
	},
	{
		path: 'users',
		pathMatch: 'full',
		loadComponent: () => import('./components/users/users-list/users-list.component').then((m) => m.UsersListComponent),
		canActivate: [AuthGuard],
	},
	{
		path: 'users/add',
		pathMatch: 'full',
		title: 'Создать пользователя',
		loadComponent: () => import('./components/users/user-edit/user-edit.component').then((m) => m.UserEditComponent),
		canActivate: [AuthGuard],
	},
	{
		path: 'users/edit/:id',
		pathMatch: 'full',
		title: 'Редактировать пользователя',
		loadComponent: () => import('./components/users/user-edit/user-edit.component').then((m) => m.UserEditComponent),
		canActivate: [AuthGuard],
	},
	{
		path: 'companies',
		pathMatch: 'full',
		loadComponent: () =>
			import('./components/companies/companies-list/companies-list.component').then((m) => m.CompaniesListComponent),
		canActivate: [AuthGuard],
	},
	{
		path: 'companies/add',
		pathMatch: 'full',
		title: 'Создать организацию',
		loadComponent: () =>
			import('./components/companies/company-edit/company-edit.component').then((m) => m.CompanyEditComponent),
		canActivate: [AuthGuard],
	},
	{
		path: 'companies/edit/:id',
		pathMatch: 'full',
		title: 'Изменить данные организации',
		loadComponent: () =>
			import('./components/companies/company-edit/company-edit.component').then((m) => m.CompanyEditComponent),
		canActivate: [AuthGuard],
	},
	{
		path: 'auth',
		pathMatch: 'full',
		loadComponent: () => import('./components/auth-page/auth-page.component').then((m) => m.AuthPageComponent),
	},
	{
		path: 'logs',
		pathMatch: 'full',
		loadComponent: () => import('./components/logs-list/logs-list.component').then((m) => m.LogsListComponent),
		canActivate: [AuthGuard],
	},
	{
		path: 'statictics',
		pathMatch: 'full',
		loadComponent: () =>
			import(
				'./components/statictics/multiple-devices-statictics-list/multiple-devices-statictics-list.component'
			).then((m) => m.MultipleDevicesStaticticsListComponent),
		canActivate: [AuthGuard],
	},
	{
		path: 'bot',
		pathMatch: 'full',
		loadComponent: () => import('./components/bot/bot-page/bot-page.component').then((m) => m.BotPageComponent),
		canActivate: [AuthGuard],
	},
	{
		path: '**',
		redirectTo: '/auth',
	},
];
